import React from 'react'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import {updateTaskComments} from '../api'

export default React.createClass({
  getInitialState: function() {
    return {
        additionalInstructions: ''
    }
  },
  sendUpdateToServer: function() {
     let taskId;
    let comment = document.getElementById('comment').value
    if(this.props.modalCard.mobileTask){
       taskId = this.props.modalCard.mobileTask.taskId
    }else{
       taskId = this.props.modalCard.taskId
    }
    updateTaskComments(taskId, comment).then((data) => {
          if(data === 'okay') {
            this.props.openNotificationModal('upgrade-instructions-modal', "Your service has been updated!", "We've updated your instructions on this task")
            this.props.hide()
          }
          else {
            this.props.openNotificationModal('upgrade-instructions-modal', "Processing Error", "There was an error processing your changes. Please try again later.")
            console.log("error")
          }
    })
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({[name]: value})

  },
  componentWillReceiveProps: function() {
    if(this.props.modalCard) {
      if(this.props.modalCard.additionalInstructions) {
        this.setState({additionalInstructions: this.props.modalCard.additionalInstructions})
      }
      else if(this.props.modalCard.comment){
        this.setState({additionalInstructions: this.props.modalCard.comment})
      }
      else if(this.props.modalCard.taskComment) {
        this.setState({additionalInstructions: this.props.modalCard.taskComment})
      }
      else if(this.props.modalCard.mobileJob && this.props.modalCard.mobileJob.comment) {
        this.setState({additionalInstructions: this.props.modalCard.mobileJob.comment})
      }
      else {
        this.setState({additionalInstructions: ''})
      }
    }
  },
  render: function () {
    let card = this.props.modalCard
    let taskType, taskTitle = '', taskIcon, instructions = '';
    if (card !== undefined && card !== '' && card !== null) {
	    taskType = card.taskType

	    let iconTypeInfo = getTaskTypeIconParser(taskType)
	    taskTitle = iconTypeInfo.prettify
	    taskIcon = iconTypeInfo.iconsrc

	    instructions = this.state.additionalInstructions
	    if(this.state.additionalInstructions.toLowerCase() === 'no instructions'){
		    instructions = ''
	    }
    }


    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upgrade-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
            <div className={'task-type center no-text'}>
              <div className={`img-responsive center-block ${taskIcon}-icon`}/>
            </div>
            <h2 className='text-center'>{taskTitle}</h2>
            <h5 className='text-center brand-primary-color'><b>Additional Instructions</b></h5>
            <br />
            <div className='row' style={{width:'90%', margin:'auto'}}>
              <FormGroup className='center-block' style={{width:'85%'}}>
                    <FormControl className='faq-text' componentClass='textarea' name='additionalInstructions' id='comment' value={instructions} placeholder='Do you have gates with codes, or any pets we need to know about? Add any extra information here if necessary.' onChange={this.handleInputChange} style={{height: 111, paddingTop: 20}}/>
              </FormGroup>
              </div>
            <div className='text-center pull-down-xs-3' style={{marginBottom: 30}}>
            <button className='btn btn-success' onClick={this.sendUpdateToServer}>Update Task</button>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/update-instructions-modal.jsx